module.exports = __webpack_public_path__ + "img/checked.375fa8f0.svg";